<script>
    export default {
        name: 'MagGrid',
        componentName: 'MagGrid',
        props: {
            size: {
                type: Number,
                default() {
                    return 0;
                }
            },
            row:{
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                w: '100%',
                h: '100%',
            }
        },
        methods: {
            resize() {
                let s = 0;
                let s0 = 0;
                this.$children.forEach(i => {
                    if (i.size) s += i.size;
                    else s0++;
                });

                this.$children.forEach(i => {
                    if(i.$options.componentName!=='MagGrid')return;
                    if (this.row) {
                        if (i.size) i.w = i.size + 'px';
                        else if (s) i.w = 'calc(' + (100 / s0) + '% - ' + (s / s0) + 'px)';
                        else i.w = (100 / s0) + '%';
                        i.h = '100%';
                    } else {
                        if (i.size) i.h = i.size + 'px';
                        else if (s) i.h = 'calc(' + (100 / s0) + '% - ' + (s / s0) + 'px)';
                        else i.h = (100 / s0) + '%';
                        i.w = '100%';
                    }
                });
            },
            resizeParent() {
                if (this.$parent && this.$parent.$options.componentName==='MagGrid') {
                    this.$parent.resize();
                }
            },
        },
        computed: {
            stl() {
                return {
                    width: this.w,
                    height: this.h,
                }
            },
            cls() {
                return{
                    'mag-grid--row': this.row,
                }
            },
        },
        watch: {
            px() {
                this.resizeParent();
            },
        },
        mounted() {
            this.resize();
        },
        updated() {
            this.resize();
        },
    }
</script>
<template>
    <div class="mag-grid" :style="stl" :class="cls">
        <slot></slot>
    </div>
</template>
<style lang="scss">
    .mag-grid {
        overflow: auto;
        box-sizing: border-box;
        &--row {
            display: flex;
            flex: 1;
            &>.mag-grid{
                flex-shrink: 1;
            }
        }
    }
</style>
